import styled from 'styled-components';

export const StyledContentViewer = styled.div<{ open: boolean }>`
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.black};
  z-index: 11;
`;

export const StyledContent = styled.div<{ open: boolean }>`
  ${({ open }) => (open ? `flex-grow: 1` : 'display: none')};
  flex-grow: 1;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
    iframe {
    border: none;
  }
`;
